module.exports = __webpack_public_path__ + "static/media/technology.700afd08.svg";